import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app-service.service';
import { BookViewerComponent } from '../book-viewer/book-viewer.component';
import { MatDialog } from '@angular/material/dialog';
import { AddInfoComponent } from '../add-info/add-info.component';
import { UserInfoComponent } from '../user-info/user-info.component';
import { SummaryImageComponent } from '../summary-image/summary-image.component';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
})
export class UserDashboardComponent implements OnInit {
  userBookDetails: any = [];
  userInfo: any = {};
  showCelebration = false;
  confettiElements: any[] = [];

  constructor(
    private appService: AppService,
    private router: Router,
    private dialog: MatDialog
  ) {
    // Check if we should show celebration (coming back from quiz completion)
    const navigation = this.router.getCurrentNavigation();
    if (
      navigation?.extras?.state &&
      navigation.extras.state['showCelebration']
    ) {
      setTimeout(() => {
        this.triggerCelebration();
        navigation.extras.state['showCelebration'] = false;
      }, 300);
    }

    // if (navigation?.extras?.state && navigation.extras.state['chapterId']) {
      
    //   this.dialog.open(SummaryImageComponent, {
    //     width: '75vh',
    //     height: '75vh',
    //     data: {
    //       finishedChapterId: navigation.extras.state['chapterId'],
    //     },
    //   });
    //   navigation.extras.state['chapterId'] = null;
    // }
  }

  ngOnInit(): void {
    this.appService.getUser().subscribe((res: any) => {
      this.userInfo = res;
      sessionStorage.setItem('userName', res.displayName);
    });
    this.getUserBooks();
  }

  getUserBooks() {
    this.appService.userChapters().subscribe((res: any) => {
      this.userBookDetails = res.sort(
        (a, b) => {
          return (
            a.chapterName.replace('Chapter ', '') -
            b.chapterName.replace('Chapter ', '')
          );
        },
        { sensitivity: 'base' }
      );
    });
  }

  openDetails(p: any) {
    this.router.navigate(['/chapter-details/' + p.chapterId]);
  }

  userBookInfo(p: any) {
    this.dialog.open(AddInfoComponent, {
      width: '85%',
      height: '85vh',
      data: p,
    });
  }

  // userChapterSave(item) {
  //   let dialog = confirm('Do You Completed Reading the ' + item.chapterName);
  //   if (dialog) {
  //     let date = new Date();
  //     var dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
  //       .toISOString()
  //       .split("T")[0];
  //     let data = {
  //       "user_id": sessionStorage.getItem('loginId'),
  //       "chapter_id": item.chapterId,
  //       "start_date": dateString,
  //       "end_date": dateString,
  //       "feedback": "Good Chapter"
  //     }

  //     this.appService.userChapter(data).subscribe((res: any) => {
  //       this.getUserBooks();
  //       this.triggerCelebration();
  //     });
  //   }
  // }

  userChapterUpdate(item) {
    let dialog = confirm('Do You Completed Reading the ' + item.chapterName);
    if (dialog) {
      let date = new Date();
      var dateString = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split('T')[0];
      let data = {
        user_id: sessionStorage.getItem('loginId'),
        chapter_id: item.chapterId,
        start_date: dateString,
        end_date: dateString,
        feedback: 'Good Chapter',
      };
      this.appService
        .userChapterUpdate(data, item.chapterId)
        .subscribe((res: any) => {
          this.getUserBooks();
        });
    }
  }

  getRewards() {
    let pointObjReg = this.appService.getPageByKey('bookStart');
    let pointObj = this.appService.getPageByKey('chapterComplete');
    let reward = +pointObjReg.title;
    this.userBookDetails.map((item: any) => {
      if (item.status == 'Completed') {
        reward += parseInt(pointObj.title);
      }
    });
    return reward;
  }

  triggerCelebration() {
    this.confettiElements = [];
    for (let i = 0; i < 100; i++) {
      this.confettiElements.push({
        x: Math.random() * 100,
        y: -10 - Math.random() * 100,
        size: 5 + Math.random() * 15,
        color: Math.floor(Math.random() * 6) + 1,
        delay: Math.random() * 2,
        duration: 3 + Math.random() * 2,
      });
    }

    this.showCelebration = true;

    setTimeout(() => {
      this.showCelebration = false;
    }, 5000);
  }

  takeQuiz(item) {
    this.router.navigate(['/chapter-details/' + item.chapterId]);
  }

  openUserInfoDialog() {
    const dialogRef = this.dialog.open(UserInfoComponent, {
      width: '500px',
      data: {
        userInfo: this.userInfo
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.userInfo = result;
        sessionStorage.setItem('userName', result.displayName);
      }
    });
  }
}
